export const ZGEventHandler = {
  callNativeFunction: function (nativeMethodName, params, callBackID, callBack) {
    var message;

    if (!callBack) {
      message = { methodName: nativeMethodName, params: params };
      window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ZGEventHandler && window.webkit.messageHandlers.ZGEventHandler.postMessage(message);
    } else {
      message = {
        methodName: nativeMethodName,
        params: params,
        callBackID: callBackID,
      };
      if (!ZGBridgeEvent._listeners[callBackID]) {
        ZGBridgeEvent.addEvent(callBackID, function (data) {
          callBack(data);
        });
      }
      window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ZGEventHandler && window.webkit.messageHandlers.ZGEventHandler.postMessage(message);
    }
  },
  callAndroidNativeFunction: function (nativeMethodName, params, callBackID, callBack) {
    if (!callBack) {
      window.ZGWebBridgeManager[nativeMethodName]();
    } else {
      if (!ZGBridgeEvent._listeners[callBackID]) {
        ZGBridgeEvent.addEvent(callBackID, function (data) {
          callBack(data);
        });
      }
      window.ZGWebBridgeManager[nativeMethodName](callBackID);
    }
  },
  newCallNativeFunction: function (
    nativeMethodName,
    params,
    callBackID,
    successCallBack,
    failureCallBack
  ) {
    var message;
    if (successCallBack && failureCallBack) {
      var successCallBackID = callBackID;
      successCallBackID += 'successCallBack';

      var failureCallBackID = callBackID;
      failureCallBackID += 'failureCallBack';

      message = {
        type: 'CallBackFunction',
        methodName: nativeMethodName,
        params: params,
        successCallBackID: successCallBackID,
        failureCallBackID: failureCallBackID,
      };
      if (!ZGBridgeEvent._listeners[successCallBackID]) {
        ZGBridgeEvent.addEvent(successCallBackID, function (data) {
          successCallBack(data);
        });
      }
      if (!ZGBridgeEvent._listeners[failureCallBackID]) {
        ZGBridgeEvent.addEvent(failureCallBackID, function (data) {
          failureCallBack(data);
        });
      }

      window.webkit.messageHandlers.ZGEventHandler.postMessage(message);
    } else if (successCallBack && !failureCallBack) {
      let successCallBackID = callBackID;
      successCallBackID += 'successCallBack';
      message = {
        type: 'CallBackFunction',
        methodName: nativeMethodName,
        params: params,
        successCallBackID: successCallBackID,
      };
      if (!ZGBridgeEvent._listeners[successCallBackID]) {
        ZGBridgeEvent.addEvent(successCallBackID, function (data) {
          successCallBack(data);
        });
      }
      window.webkit.messageHandlers.ZGEventHandler.postMessage(message);
    } else if (failureCallBack && !successCallBack) {
      let failureCallBackID = callBackID;
      failureCallBackID += 'failureCallBack';
      message = {
        type: 'CallBackFunction',
        methodName: nativeMethodName,
        params: params,
        failureCallBackID: failureCallBackID,
      };
      if (!ZGBridgeEvent._listeners[failureCallBackID]) {
        ZGBridgeEvent.addEvent(failureCallBackID, function (data) {
          failureCallBack(data);
        });
      }
      window.webkit.messageHandlers.ZGEventHandler.postMessage(message);
    } else {
      message = {
        type: 'CallBackFunction',
        methodName: nativeMethodName,
        params: params,
      };
      window.webkit.messageHandlers.ZGEventHandler.postMessage(message);
    }
  },

  callBack: function (callBackID, data) {
    console.log(callBackID, data)
    ZGBridgeEvent.fireEvent(callBackID, data);
  },

  removeAllCallBacks: function () {
    ZGBridgeEvent._listeners = {};
  },

  removeCallBack: function (callBackID) {
    if (ZGBridgeEvent._listeners[callBackID]) {
      ZGBridgeEvent.removeEvent(callBackID);
    }
  }
};

var ZGBridgeEvent = {
  _listeners: {},
  addEvent: function (type, fn) {
    if (typeof this._listeners[type] === 'undefined') {
      this._listeners[type] = [];
    }
    if (typeof fn === 'function') {
      this._listeners[type].push(fn);
    }
    return this;
  },

  fireEvent: function (type, param) {
    var arrayEvent = this._listeners[type];
    if (arrayEvent instanceof Array) {
      for (var i = 0, length = arrayEvent.length; i < length; i += 1) {
        if (typeof arrayEvent[i] === 'function') {
          arrayEvent[i](param);
        }
      }
    }

    return this;
  },

  removeEvent: function (type, fn) {
    var arrayEvent = this._listeners[type];
    if (typeof type === 'string' && arrayEvent instanceof Array) {
      if (typeof fn === 'function') {
        for (var i = 0, length = arrayEvent.length; i < length; i += 1) {
          if (arrayEvent[i] === fn) {
            this._listeners[type].splice(i, 1);
            break;
          }
        }
      } else {
        delete this._listeners[type];
      }
    }

    return this;
  },
};
